// Labeled horizontal-bar list — Top Corrective Categories, Hotspot Projects.
// items: [{ label, value }]
import { toPlainText } from "../utils/plainText";
import "../reportDashboard.scss";

// labelMaxWidth (optional): caps the label column so a long name can't crowd
// the value beside it — v26 does this inline (max-width:180px) on the one row
// (Hotspot Projects) whose labels run long; `.rdHBar__label` already has
// overflow:hidden/ellipsis, this just gives that a width to actually clip at.
const HBarList = ({
  items,
  tone = "accent",
  emptyLabel = "No data",
  onItemClick,
  labelMaxWidth,
}) => {
  if (!items || items.length === 0) {
    return <div className="rdEmpty">{emptyLabel}</div>;
  }
  const max = Math.max(...items.map((i) => i.value), 1);
  return (
    <div className="rdHBar">
      {items.map((item) => {
        // key stays raw — uniqueness only; labels differing solely in markup must not collide
        const label = toPlainText(item.label);
        return (
          <div
            key={item.label}
            className={
              onItemClick
                ? "rdHBar__item rdHBar__item--clickable"
                : "rdHBar__item"
            }
            onClick={onItemClick ? () => onItemClick(item) : undefined}
          >
            <div className="rdHBar__head">
              <span
                className="rdHBar__label"
                title={label}
                style={labelMaxWidth ? { maxWidth: labelMaxWidth } : undefined}
              >
                {label}
              </span>
              <span className="rdHBar__value">{item.value}</span>
            </div>
            <div className="rdBar rdBar--thin">
              <div
                className={`rdBar__fill is-${tone}`}
                style={{ "--rd-fill": `${(item.value / max) * 100}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HBarList;
